import CarBreadcrumb from "../../commonComponents/breadcrumbs/CarBreadcrumb";
import CarDetail from "../../commonComponents/productDetail/CarDetail";

const CarClassicContainer = () => {
  return (
    <>
      <CarBreadcrumb type="car_detail" detailImages />
      <CarDetail type="car" detailImages />
    </>
  );
};

export default CarClassicContainer;
